export default "__VITE_ASSET__Coi7CS2C__"